import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { filterUndefineds } from '@olivierpascal/helpers';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetLiveStreamsRequestBody,
  IApiGetLiveStreamsResponseBody,
} from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseLiveStreamsQueryValues = {
  appId: string;
  body?: IApiGetLiveStreamsRequestBody;
};

export const liveStreamsQueryKeyFactory: IQueryKeyFactory<
  IUseLiveStreamsQueryValues
> = (values) =>
  values && filterUndefineds(['liveStreams', values.appId, values.body]);

export const useLiveStreamsQuery = (
  values?: IUseLiveStreamsQueryValues,
  options?: UseQueryOptions<IApiGetLiveStreamsResponseBody, ApiError>,
): UseQueryResult<IApiGetLiveStreamsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: liveStreamsQueryKeyFactory(values),
    queryFn: values
      ? () => api.liveStreams.getAll(values.appId, values.body)
      : undefined,
    ...options,
  });
};
